<template>
  <v-card>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-card-title>{{ $t('Create new consultant') }}</v-card-title>
          <v-card-text>
            <v-text-field solo v-model="editItem.name" label="User name"></v-text-field>
            <v-text-field solo v-model="editItem.user.email" label="Email"></v-text-field>

            <v-text-field
              solo
              v-model="editItem.user.password"
              :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              :type="showPassword ? 'text' : 'password'"
              name="input-10-1"
              :label="$t('Password')"
              @click:append="showPassword = !showPassword"
            ></v-text-field>

            <!-- <v-autocomplete v-model="editItem.categories" :items="['Fiscal', 'Laboral', 'Contable', 'Otros']" label="Categoría"
                            multiple chips>
            </v-autocomplete>-->
            <category-select solo v-model="editItem.categories" item-value="name"></category-select>

            <input type="hidden" v-model="editItem.role" />
            <div class="profile consultant-profile profile-commons">
              <v-text-field solo v-model="editItem.nif" :label="$t('nif')"></v-text-field>

              <v-text-field solo v-model="editItem.address" :label="$t('address')"></v-text-field>
              <v-text-field solo v-model="editItem.city" :label="$t('city')"></v-text-field>
              <v-text-field solo v-model="editItem.cp" :label="$t('cp')"></v-text-field>
              <v-text-field solo v-model="editItem.province" :label="$t('province')"></v-text-field>
              <v-text-field solo v-model="editItem.region" :label="$t('region')"></v-text-field>
              <v-text-field solo v-model="editItem.country" :label="$t('country')"></v-text-field>
              <v-text-field solo v-model="editItem.phone" :label="$t('phone')"></v-text-field>
              <v-text-field solo v-model="editItem.mobile" :label="$t('mobile')"></v-text-field>

              <v-textarea
                solo
                v-model="editItem.description"
                :label="$t('description')"
              ></v-textarea>
            </div>
            <div
              class="profile consultant-profile profile-autonomous"
              v-if="editItem.roles.indexOf('autonomous') >= 0"
            >
              <!-- AUTONOMOUS  SPECIFIC FIELDS-->
            </div>
            <div
              class="profile consultant-profile profile-pyme"
              v-if="editItem.roles.indexOf('pyme') >= 0"
            >
              <!-- PYME  SPECIFIC FIELDS-->
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="info" @click="close">{{ $t('go back') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="save">{{ $t('save') }}</v-btn>
          </v-card-actions>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import profileAPI from '@/services/api/profile.js';
import CategorySelect from '@/components/commons/CategorySelect.vue';
export default {
  components: {
    CategorySelect,
  },
  props: ['editItem', 'editIndex'],
  data() {
    return {
      formDialog: true,
      profile: 'consultant',
      dateMenu: false,
      date: null,
      showPassword: false,
      role: 'consultant',
    };
  },

  mounted() {},
  methods: {
    close() {
      this.$emit('closeDialog', true);
    },
    save() {
      let data = {
        user: {
          email: this.editItem.user.email,
          name: this.editItem.name,
          password: this.editItem.user.password,
          role: 'consultant',
        },
        nif: this.editItem.nif,
        // social_name : this.editItem.social_name,
        // constitution_date : this.editItem.constitution_date,
        address: this.editItem.address,
        city: this.editItem.city,
        cp: this.editItem.cp,
        province: this.editItem.province,
        region: this.editItem.region,
        country: this.editItem.country,
        phone: this.editItem.phone,
        // primary_activity : this.editItem.primary_activity,
        description: this.editItem.description,
        categories: this.editItem.categories,
      };

      if (this.editItem.hasOwnProperty('id') && this.editItem.id) {
        profileAPI.updateProfile(this.profile, data, this.editItem.id).then(res => {
          this.$emit('profileSaved', {
            profile: res.data.data,
            index: this.editIndex,
          });
        });
      } else {
        profileAPI.postProfile(this.profile, data).then(res => {
          this.$emit('profileSaved', { profile: res.data.data, index: null });
        });
      }
    },
  },
};
</script>
